type FileNameProps = {
  title: string;
};

const FileName = ({ title }: FileNameProps) => {
  const indexOfStartFormatName = title?.lastIndexOf('.') ?? -1;
  const possibleExtension = indexOfStartFormatName >= 0 ? title.slice(indexOfStartFormatName + 1) : '';
  const isValidExtension =
    indexOfStartFormatName > 0 && indexOfStartFormatName < title.length - 1 && /^[a-z0-9]+$/i.test(possibleExtension);
  const fileName = isValidExtension ? title.slice(0, indexOfStartFormatName) : title;
  const type = isValidExtension ? `.${possibleExtension}` : '';

  return (
    title && (
      <>
        <span title={title} className="files-list__files-name" data-testid="artifact-name">
          {fileName}
        </span>
        <span className="files-list__files-type" data-testid="artifact-type">
          {type}
        </span>
      </>
    )
  );
};

export default FileName;
